<script>
  // Wraps a row of <StatTile> in a consistent DaisyUI stats container. Replaces the
  // copy-pasted `stats stats-vertical sm:stats-horizontal …` wrapper across dashboards.
  let { children } = $props()
</script>

<div class="stats stats-vertical sm:stats-horizontal bg-base-100 shadow-sm border border-base-300 w-full mb-6">
  {@render children()}
</div>
